export default {
  title: 'แจ้งซ่อม',
  description: 'ติดตามและจัดการแจ้งซ่อมจากผู้เช่า',
  new_request: 'แจ้งซ่อมใหม่',
  edit_request: 'แก้ไขแจ้งซ่อม',
  request_detail: 'รายละเอียดแจ้งซ่อม',

  labels: {
    title: 'หัวข้อ',
    description: 'รายละเอียด',
    category: 'หมวดหมู่',
    priority: 'ความสำคัญ',
    status: 'สถานะ',
    notes: 'บันทึก',
    unit: 'ห้อง',
    customer: 'ผู้เช่า',
    property: 'อสังหาริมทรัพย์',
    photos: 'รูปภาพ',
    photo: 'รูปภาพ',
    created_at: 'วันที่แจ้ง',
    completed_at: 'วันที่เสร็จ',
    created: 'วันที่แจ้ง',
    completed: 'วันที่เสร็จ',
    date: 'วันที่',
    duration: 'ระยะเวลา',
    today: 'วันนี้',
    day: 'วัน',
    days: 'วัน',
  },

  status: {
    all: 'ทั้งหมด',
    open: 'เปิด',
    in_progress: 'กำลังดำเนินการ',
    completed: 'เสร็จสิ้น',
  },

  categories: {
    plumbing: 'ประปา',
    electrical: 'ไฟฟ้า',
    hvac: 'เครื่องปรับอากาศ',
    appliance: 'เครื่องใช้ไฟฟ้า',
    structural: 'โครงสร้าง',
    pest_control: 'กำจัดสัตว์รบกวน',
    cleaning: 'ทำความสะอาด',
    other: 'อื่นๆ',
  },

  priority: {
    low: 'ต่ำ',
    normal: 'ปกติ',
    urgent: 'เร่งด่วน',
  },

  actions: {
    new_request: 'แจ้งซ่อมใหม่',
    create_request: 'สร้างแจ้งซ่อม',
    update_request: 'อัปเดตแจ้งซ่อม',
    mark_in_progress: 'เปลี่ยนเป็นกำลังดำเนินการ',
    mark_completed: 'เปลี่ยนเป็นเสร็จสิ้น',
    add_notes: 'เพิ่มบันทึก',
    back_to_list: 'กลับไปรายการ',
  },

  form: {
    title_new: 'แจ้งซ่อมใหม่',
    title_edit: 'แก้ไขแจ้งซ่อม',
    description_new: 'สร้างแจ้งซ่อมใหม่สำหรับห้อง',
    description_edit: 'อัปเดตรายละเอียดแจ้งซ่อม',
    select_category: 'เลือกหมวดหมู่',
    select_property: 'เลือกอสังหาริมทรัพย์',
    select_unit: 'เลือกห้อง',
    no_customer: 'ไม่ระบุผู้เช่า',
    title_placeholder: 'เช่น ก๊อกน้ำรั่วในห้องครัว',
    description_placeholder: 'อธิบายรายละเอียดปัญหา...',
    category_note: 'ระบุรายละเอียด',
    category_note_placeholder: 'เช่น กุญแจประตูเสีย',
  },

  detail: {
    info_title: 'ข้อมูลแจ้งซ่อม',
    created_on: 'สร้างเมื่อ {{date}}',
  },

  placeholders: {
    title: 'เช่น ก๊อกน้ำรั่วในห้องครัว',
    description: 'อธิบายรายละเอียดปัญหา...',
    notes: 'เพิ่มบันทึกการซ่อม...',
    select_unit: 'เลือกห้อง',
    select_customer: 'เลือกผู้เช่า',
    select_category: 'เลือกหมวดหมู่',
    select_priority: 'เลือกความสำคัญ',
  },

  messages: {
    created: 'สร้างแจ้งซ่อมแล้ว',
    updated: 'อัปเดตแจ้งซ่อมแล้ว',
    deleted: 'ลบแจ้งซ่อมแล้ว',
    delete_title: 'ลบแจ้งซ่อม',
    delete_confirm: 'คุณแน่ใจหรือไม่ว่าต้องการลบ "{{title}}"?',
    status_updated: 'อัปเดตสถานะเป็น {{status}} แล้ว',
    error_loading: 'เกิดข้อผิดพลาดในการโหลด',
    error_description: 'เกิดข้อผิดพลาดในการโหลดแจ้งซ่อม',
  },

  empty: {
    title: 'ไม่มีแจ้งซ่อม',
    description: 'แจ้งซ่อมจากผู้เช่าจะปรากฏที่นี่',
    not_found: 'ไม่พบแจ้งซ่อม',
  },

  setup_guide: {
    title: 'เริ่มต้นใช้งานแจ้งซ่อม',
    description: 'ติดตามและจัดการแจ้งซ่อมจากผู้เช่าของคุณ',
    prerequisites_title: 'สิ่งที่ต้องมี',
    prereq_property: 'อสังหาริมทรัพย์อย่างน้อย 1 แห่งที่มีห้อง',
    prereq_setup_property: 'ตั้งค่าอสังหาริมทรัพย์',
    step_1_title: 'ตั้งค่าห้อง',
    step_1_description: 'สร้างอสังหาริมทรัพย์และห้องก่อน',
    step_2_title: 'สร้างแจ้งซ่อม',
    step_2_description: 'บันทึกแจ้งซ่อมสำหรับห้อง',
    step_3_title: 'ติดตามสถานะ',
    step_3_description: 'อัปเดตสถานะแจ้งซ่อมตามความคืบหน้า',
    prerequisites: {
      units: 'อสังหาริมทรัพย์อย่างน้อย 1 แห่งที่มีห้อง',
    },
    steps: {
      create_unit: {
        title: 'ตั้งค่าห้อง',
        description: 'สร้างอสังหาริมทรัพย์และห้องก่อน',
      },
      create_request: {
        title: 'สร้างแจ้งซ่อม',
        description: 'บันทึกแจ้งซ่อมสำหรับห้อง',
      },
      track_status: {
        title: 'ติดตามสถานะ',
        description: 'อัปเดตสถานะแจ้งซ่อมตามความคืบหน้า',
      },
    },
  },

  filters: {
    all: 'ทั้งหมด',
    all_properties: 'ทุกอาคาร',
    open: 'เปิด',
    in_progress: 'กำลังดำเนินการ',
    completed: 'เสร็จสิ้น',
    date_from: 'ตั้งแต่',
    date_to: 'ถึง',
    search_placeholder: 'ค้นหาหัวข้อ...',
  },

  errors: {
    validation_failed: 'ข้อมูลไม่ถูกต้อง กรุณาตรวจสอบแบบฟอร์มอีกครั้ง',

    fields: {
      title: 'หัวข้อ',
      description: 'รายละเอียด',
      category: 'หมวดหมู่',
      priority: 'ความสำคัญ',
      status: 'สถานะ',
      unit_id: 'ห้อง',
      customer_id: 'ผู้เช่า',
    },

    codes: {
      blank: 'ต้องไม่เว้นว่าง',
      taken: 'ถูกใช้แล้ว',
      invalid: 'ไม่ถูกต้อง',
      too_short: 'สั้นเกินไป',
      too_long: 'ยาวเกินไป',
      inclusion: 'ค่าไม่อยู่ในรายการที่อนุญาต',
    },
  },
}
